import { Map as map } from 'immutable';
const C = require("../constants");

function ComboReducer(state = map(), action) {
    switch (action.type) {
        case C.COMBO:
            return action.data;
        case C.COMBO_REMOVE:
            return state.filter(data => {
                return data.id !== action.data
            });
        case C.COMBO_ADD:
            return state.concat(action.data);
        default:
            return state;
    }
}

export default ComboReducer;


// WEBPACK FOOTER //
// ./src/reducers/ComboReducer.js